import { render } from "./EmployeesTable.vue?vue&type=template&id=4392a94a"
import script from "./EmployeesTable.vue?vue&type=script&lang=js"
export * from "./EmployeesTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__